module.exports = __webpack_public_path__ + "static/Ola_2_min-2eba41ba8b77de35b58c2eb2c00df0dd.jpg";